"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = withFilter;

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _coreDecorators = require("core-decorators");

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = require("./utils");

var _invariant = _interopRequireDefault(require("invariant"));

var ASC = 'asc';
var DESC = 'desc';

function withFilter(filterConfig, namespace) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      filterValues = _ref.filterValues,
      sortingValues = _ref.sortingValues,
      _setFilters = _ref.setFilters,
      _setSorting = _ref.setSorting,
      onChange = _ref.onChange,
      initialValues = _ref.initialValues;

  return function (WrappedComponent) {
    var _dec, _class, _class2, _temp;

    var WithFilter = (_dec = (0, _coreDecorators.decorate)(_lodash.default.memoize), (0, _coreDecorators.autobind)(_class = (_class2 = (_temp =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inherits2.default)(WithFilter, _PureComponent);

      function WithFilter() {
        var _getPrototypeOf2;

        var _this;

        (0, _classCallCheck2.default)(this, WithFilter);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(WithFilter)).call.apply(_getPrototypeOf2, [this].concat(args)));
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "namespace", namespace || filterConfig.namespace);
        return _this;
      }

      (0, _createClass2.default)(WithFilter, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          var newNamespace = (0, _utils.objectOrFunc)(namespace, nextProps);

          if (newNamespace !== this.namespace && newNamespace) {
            this.namespace = newNamespace;
          }
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var _componentDidMount = (0, _asyncToGenerator2.default)(
          /*#__PURE__*/
          _regenerator.default.mark(function _callee() {
            var _this2 = this;

            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!initialValues) {
                      _context.next = 7;
                      break;
                    }

                    _context.next = 3;
                    return this.setFilters((0, _utils.objectOrFunc)(initialValues, this.props).filters);

                  case 3:
                    _context.next = 5;
                    return this.setSorting((0, _utils.objectOrFunc)(initialValues, this.props).sorting);

                  case 5:
                    _context.next = 11;
                    break;

                  case 7:
                    _context.next = 9;
                    return this.setSorting(_lodash.default.reduce(filterConfig.sorting, function (accum, individualFilterConfig, filterId) {
                      var vals = sortingValues(_this2.namespace, _this2.props);
                      var currentValue = vals[filterId];
                      var filterDefaultValue = individualFilterConfig.initialValue;

                      if (!currentValue && filterDefaultValue) {
                        accum[filterId] = filterDefaultValue;
                      }

                      return accum;
                    }, {}));

                  case 9:
                    _context.next = 11;
                    return this.setFilters(_lodash.default.reduce(filterConfig.filters, function (accum, individualFilterConfig, filterId) {
                      var vals = sortingValues(_this2.namespace, _this2.props);
                      var currentValue = vals[filterId];
                      var filterDefaultValue = individualFilterConfig.initialValue;

                      if (!currentValue && filterDefaultValue) {
                        accum[filterId] = filterDefaultValue;
                      }

                      return accum;
                    }, {}));

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function componentDidMount() {
            return _componentDidMount.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: "setFilters",
        value: function setFilters(filtersObject) {
          _lodash.default.forEach(filtersObject, function (value, key) {
            (0, _invariant.default)(_lodash.default.includes(_lodash.default.keys(filterConfig.filters), key), "\"".concat(key, "\" is not a valid filter column defined in the \"").concat(filterConfig.namespace, "\" filter config"));
          });

          var setFilterFunc = _lodash.default.isFunction(_setFilters) ? _setFilters(this.props) : _setFilters;
          return _promise.default.resolve(setFilterFunc(this.namespace, filtersObject)).then(function (result) {
            if (onChange) onChange(result);
          });
        }
      }, {
        key: "setSorting",
        value: function setSorting(sortingObject) {
          (0, _invariant.default)(_lodash.default.every(sortingObject, function (value) {
            return value === ASC || value === DESC || !value;
          }), 'Invalid sorting value: you can only sort columns by "asc" or "desc"');

          _lodash.default.forEach(sortingObject, function (value, key) {
            (0, _invariant.default)(_lodash.default.includes(_lodash.default.keys(filterConfig.sorting), key), "\"".concat(key, "\" is not a valid sorting column defined in the \"").concat(filterConfig.namespace, "\" filter config"));
          });

          var setSortingFunc = (0, _utils.objectOrFunc)(_setSorting, this.props);
          return _promise.default.resolve(setSortingFunc(this.namespace, sortingObject)).then(function (result) {
            if (onChange) onChange(result);
          });
        }
      }, {
        key: "reset",
        value: function () {
          var _reset = (0, _asyncToGenerator2.default)(
          /*#__PURE__*/
          _regenerator.default.mark(function _callee2() {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return this.componentDidMount();

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function reset() {
            return _reset.apply(this, arguments);
          }

          return reset;
        }()
      }, {
        key: "set",
        value: function () {
          var _set = (0, _asyncToGenerator2.default)(
          /*#__PURE__*/
          _regenerator.default.mark(function _callee3(object) {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return this.setFilters(object.filters);

                  case 2:
                    _context3.next = 4;
                    return this.setSorting(object.sorting);

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));

          function set(_x) {
            return _set.apply(this, arguments);
          }

          return set;
        }()
      }, {
        key: "getFiltersProp",
        value: function getFiltersProp(valuesString) {
          var setFilters = this.setFilters,
              setSorting = this.setSorting,
              reset = this.reset,
              set = this.set;
          return {
            setFilters: setFilters,
            setSorting: setSorting,
            set: set,
            reset: reset,
            sortingValues: (0, _utils.objectOrFunc)(sortingValues, this.namespace, this.props),
            filterValues: (0, _utils.objectOrFunc)(filterValues, this.namespace, this.props),
            config: filterConfig
          };
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
            filters: this.getFiltersProp((0, _stringify.default)({
              sortingValues: (0, _utils.objectOrFunc)(sortingValues, this.namespace, this.props),
              filterValues: (0, _utils.objectOrFunc)(filterValues, this.namespace, this.props)
            }))
          }));
        }
      }]);
      return WithFilter;
    }(_react.PureComponent), _temp), ((0, _applyDecoratedDescriptor2.default)(_class2.prototype, "getFiltersProp", [_dec], (0, _getOwnPropertyDescriptor.default)(_class2.prototype, "getFiltersProp"), _class2.prototype)), _class2)) || _class);
    return WithFilter;
  };
}